export type GuestListTicketVisibility = {
  inviteOnly?: boolean;
  linkOnly?: boolean;
  hideFromNonGuests?: boolean;
  /** null means signed out; signed-in viewers are checked on the server. */
  guestListEligible?: boolean | null;
};

export function isTicketVisibleOnEvent(
  pass: GuestListTicketVisibility,
): boolean {
  return (
    !pass.linkOnly &&
    !(
      pass.inviteOnly &&
      pass.hideFromNonGuests &&
      pass.guestListEligible === false
    )
  );
}

export function guestListTicketMessage(
  eligible: boolean | null | undefined,
): string {
  if (eligible === true) return "You're on the guest list. Claim your ticket.";
  if (eligible === false) return "This ticket is for invited guests.";
  return "Sign in to check the guest list.";
}
